import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M4.115 18.333q-.679 0-1.163-.489a1.62 1.62 0 0 1-.483-1.177V5h1.646v11.667h9.052v1.666zM7.406 15q-.679 0-1.162-.49a1.62 1.62 0 0 1-.484-1.177v-10q0-.687.484-1.177t1.162-.49h7.407q.678 0 1.162.49t.483 1.177v10q0 .688-.483 1.178-.483.489-1.162.489zm0-1.667h7.407v-10H7.406z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }